import React, {useEffect} from 'react';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import TimerIcon from '@material-ui/icons/Timer';

import {useDispatch, useSelector} from "react-redux";
import {renderMilisecondsToTimeDuration} from "../../../utils/datetimehelp";
import {getColorForPercentage} from "../../../utils/utils";
import {getEstacoesTrabalho} from "../../../actions/i4Actions";
import {
    convertISODateTimeToDDMMHHmmBRLocale,
    convertISODateTimeToHHmmBRLocale,
    convertSecondsToHourMinutesFormat
} from "../../../common/Util";

const useStyles = makeStyles(theme => ({

    gridExterno: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 3,
        backgroundColor: 'white',
        margin: '4px',
        // padding: '4px',
     //   borderRadius: '15px',
     //   minHeight: '150px',
     //   marginBottom:'30px',
        // width: '120px'

    },
    mainGrid: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
        alignSelf: 'flex-start',
        padding: 3
    },

    nomeEtapa: {
        //backgroundColor: 'red',
        display: 'flex',
        justifyContent: 'center',
        alignSelf: 'center',
        borderBottom: '1px solid red'
    },
    valoresArea: {
      //  backgroundColor: 'green'
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',

    },
    fila: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    concluidos: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    tempomedio: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        alignSelf: 'center',
        fontSize:'2rem'
    },
    tempoLabel: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'flex-end',
        paddingTop: '2px'
    },
    tempoValor: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'space-evenly'

    },
    operadores: {
        display: 'flex',
        flexDirection: 'row',
        flexwrap: 'wrap',
        justifyItems: 'center',
        justifyContent: 'space-evenly'

    },
    estacao: {
        marginBottom: '4px'
    }


}));

const POperadores = () => {

    const classes= useStyles();
    const estacoesTrabalho = useSelector(state => state.i4.estacoesTrabalho );
    const operadores = useSelector(state => state.stations.operadores );
    const loginLogoutsHoje = useSelector(state => state.i4.loginLogoutsHoje );
    const processos = useSelector(state => state.i4.processos );
    const ixProcessoPadrao = processos.findIndex(p => p.id === 1);
    const dispatch = useDispatch();


    useEffect(()=>{
        //  getPage()
        const interval=setInterval(()=>{
            dispatch(getEstacoesTrabalho());;
        },5000);
        return()=>clearInterval(interval)
    },[estacoesTrabalho])


        return (
            <Grid id="operadoresGridExt" item container className={classes.gridExterno} xs={12} sm={12} md={12} lg={12} xl={12}>





                <Grid id="operadoresMainGridLogins" container item className={classes.mainGrid} xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid item className={classes.nomeEtapa} xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="h4">LOGINS-LOGOUTS</Typography>
                    </Grid>
                    <Grid item container className={classes.operadores} xs={12} sm={12} lg={12} xl={12}>
                        <Grid item container className={classes.estacao} style={{ display: 'flex', justifyContent: `space-between` }}  xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid item xs={2} sm={2} md={4} lg={4} xl={4}>
                                <Typography variant="h4"  >OPERADOR</Typography>
                            </Grid>

                            <Grid item xs={4} sm={4} md={4} lg={4} xl={2}>
                                <Typography variant="h4" >LOGIN</Typography>
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={2} xl={2}>
                                <Typography  variant="h4" >LOGOUT</Typography>
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={2} xl={2} style={{ display:'flex', justifyContent: 'flex-end' }} >
                                <Typography variant="h4" >DURAÇÃO</Typography>
                            </Grid>

                        </Grid>
                        {
                            loginLogoutsHoje
                                .map( (llh,ix) => {

                                    let soper = {
                                        nome : 'N/A'
                                    }
                                    if (operadores) {
                                      soper = operadores.find(oo => oo.id === llh.operadorId);
                                    }

                                    let tempo = 0
                                    if (!llh.dtLogout) { tempo = (new Date().getTime()) ; }
                                      else { tempo = new Date(llh.dtLogout).getTime(); }


                                  let cor = 'none'
                                  if ((tempo - new Date(llh.dt).getTime()) > (60 * 60 * 1000 * 5 )) // 5 horas
                                      cor = 'red';

                                   return (
                                       <Grid item container className={classes.estacao} style={{ display: 'flex', justifyContent: `space-between`, backgroundColor: cor }}  key={ix} xs={12} sm={12} md={12} lg={12} xl={12}>
                                           <Grid item xs={2} sm={2} md={1} lg={4} xl={4}>
                                               <Typography key={ix} variant="h4"  >{soper? soper.nome : '--'}({llh.operadorId}) </Typography>
                                           </Grid>
                                           <Grid item xs={4} sm={4} md={4} lg={4} xl={2}>
                                               <Typography key={ix} variant="h4" >{convertISODateTimeToDDMMHHmmBRLocale(llh.dt)} </Typography>
                                           </Grid>
                                           <Grid item xs={4} sm={3} md={2} lg={2} xl={2}>
                                               <Typography key={ix} variant="h4" >{convertISODateTimeToHHmmBRLocale(llh.dtLogout)}</Typography>
                                           </Grid>
                                           <Grid item xs={4} sm={3} md={2} lg={2} xl={2} style={{ display:'flex', justifyContent: 'flex-end' }} >
                                               <Typography key={ix} variant="h4" >{renderMilisecondsToTimeDuration(tempo - new Date(llh.dt).getTime())}</Typography>
                                           </Grid>

                                       </Grid>
                                   );
                                })
                        }
                    </Grid>
                </Grid>
            </Grid>
        )
    }

export default POperadores;


